import { Box, Button, Typography, useTheme } from "@mui/material";
import React from "react";
import styles from "./sectionCard.module.css";

const SectionCard = ({icon, header, title, desc, locked, link}: {
    icon: string,
    header: string,
    title: string,
    desc: string,
    locked: Boolean,
    link: string
}) => {
    const theme = useTheme();
    
    const handleClick = (url: string) => {
        window.open(url, '_blank');
    };

    return (
        <Box className={styles.sectionCard} >
            <Box className={styles.sectionAboveHeader}>
                <Box component={"img"} sx={{width: '29px', height: '22px', marginBottom: '10px', display: 'inline-block', }}
                    src={icon}/>
                <Typography variant="h5" gutterBottom sx={{display: 'inline-block', marginLeft: '6px',
                    [theme.breakpoints.down(900)]: {
                        position: "relative",
                        bottom: "3px"
                    }
                }}>
                    {header}
                </Typography>
            </Box>
            
            <Box className={`${styles.sectionBody} ${locked ? '' : styles.sectionBodyLock}`} sx={{display: 'flex', justifyContent: 'center' }}>
                <Box className={styles.sectionContent}>
                    <Typography variant="subtitle1" gutterBottom>
                        {title}
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                        {desc}
                    </Typography>
                </Box>

                <Box className={styles.sectionButton}>
                    <Button className={locked ? styles.unlocked : styles.locked} onClick={() => handleClick(link)}>
                        {locked ? "" : <img src="https://members.performancegolf.com/wp-content/uploads/2025/04/Lock.png" alt="" style={{ marginRight: "5px" }} />} {locked ? "Get Started" : "Unlock"}
                    </Button>
                </Box>
            </Box>
        </Box>
    );
}

export default SectionCard;